<template>
  <div>
    <div class="page">
      <!--导航栏-->
      <div class="navbar-box">
        <div class="nav-inner">
          <div style="float: left">
            <img src="@/assets/logo.png" alt="logo" style="height: 33px; width: 246px; margin-top: 20px">
          </div>
          <div style="float: left; color: #eee; line-height: 70px; font-size: 24px;margin-left: 10px">二代证阅读器</div>
          <!--右侧-->
          <el-menu
            class="navbar"
            :default-active="$route.path"
            mode="horizontal"
            background-color="#363636"
            text-color="#eee"
            active-text-color="#5DADE2"
            router
            style="float: right">
            <el-menu-item index="/index">首页</el-menu-item>
            <el-menu-item index="/product">产品设备</el-menu-item>
            <el-menu-item index="/download">资料下载</el-menu-item>
            <el-menu-item index="/about">关于我们</el-menu-item>
          </el-menu>
        </div>
      </div>
      <div style="margin-top: 70px">
        <router-view/>
      </div>
    </div>
    <!--页脚-->
    <footer class="footer-outer">
      <div class="footer-inner">
        <!--左侧内容-->
        <div style="float: left; margin-top: 18px;margin-left: 30px">
          <img src="@/assets/logo1.png" alt="" style="width: 180px; margin-left: 60px">
          <div style="display: flex; margin-top: 20px">
            <div style="margin-right: 20px; color: #ddd">版权所有 ◎ 2024</div>
            <a href="http://www.beian.miit.gov.cn/publish/query/indexFirst.action" target="_blank">黑ICP备08101720号-2</a>
          </div>
        </div>
        <!--右侧内容-->
        <div style="float: right; margin-top: 15px; display: flex">
          <!--联系我们-->
          <div>
            <p style="font-weight: bold; color: red; margin: 5px 0;">联系我们</p>
            <p style="color: #ddd; margin: 10px 0;">安徽新中新华科电子有限公司<br/>
              生产地址：黑龙江省哈尔滨市南岗区学府路副380号<br/>
              销售电话：15901001979<br/>售后电话：0451-82380402</p>
          </div>
          <!--微信公众号二维码-->
          <div style="margin: 0 30px 0 90px">
            <img src="@/assets/qrcode.jpg" alt="" style="width: 100px">
            <div style="text-align: center; color: #ddd">微信公众号</div>
          </div>
        </div>
      </div>
    </footer>
    <q-qtalk></q-qtalk>
  </div>
</template>

<script>
import QQtalk from '@/components/QQtalk'

export default {
  name: 'MainPage',
  components: { QQtalk }
}
</script>

<style scoped lang="scss">
  // 导航栏
  .navbar-box {
    background: #363636;
    box-shadow: 0 1px 10px rgba(0, 21, 20, .6);
    z-index: 1000;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
  }

  .nav-inner {
    width: 1200px;
    margin: 0 auto;
    height: 70px;
  }

  .navbar {
    margin-left: 20px;

    .el-menu-item {
      * {
        vertical-align: top;
      }
    }
  }

  .el-menu--horizontal {
    border-bottom: 0;
  }

  // menu hover
  .el-menu-item {
    font-size: 18px;
    height: 70px;
    line-height: 70px;
    padding: 0 24px;
    letter-spacing: .07em;

    &:hover {
      color: #5DADE2 !important;
    }
  }

  // 页脚
  .footer-outer {
    height: 150px;
    width: 100%;
    margin-top: 50px;
    background-color: #404040;
    border-top: 1px solid #f0f0f0;

    .footer-inner {
      width: 1200px;
      margin: 0 auto;
    }
  }
</style>
